// Cierre del negocio — no sobrecostear la operación.
//
// Proveedor: da PRECIO PREFERENCIAL. Se le paga el 100% de esa tarifa.
// Cliente: paga el precio de LISTA del modelado (Sección A).
// Margen Alebas = lista − preferencial (nunca negativo: si no hay spread, no se inventa un %).
// De ese margen se GUARDA 60% gastos admin y 40% mantenimiento de la plataforma.
//
// Técnico: ÉL cobra la instalación. El 80% es su neto. El 20% NO es ganancia neta
// de Solar Hub: se REINVIERTE en infraestructura, capacitaciones y mantener al
// día las herramientas de modelado. Base de obra = budget.ins.

export const CARGO_ADMIN_TEC_PCT = 20;
export const TECH_EARNINGS_PCT = 100 - CARGO_ADMIN_TEC_PCT;
/** Del 20% de reinversión: 40% infra, 30% capacitaciones, 30% herramientas de modelado. */
export const INFRA_DE_REINVERSION = 0.4;
export const CAPACITACION_DE_REINVERSION = 0.3;
export const HERRAMIENTAS_DE_REINVERSION = 0.3;
export const ADMIN_DE_MARGEN = 0.6;
export const MANT_DE_MARGEN = 0.4;
/** @deprecated el 10% ya no se descuenta al proveedor; se deja por compat de imports. */
export const PLATFORM_FEE_EQUIPMENT_PCT = 10;

function presupuestoDe(q) {
  if (!q) return {};
  const pld = q.payload && typeof q.payload === 'object' ? q.payload : {};
  return q.budget || pld.budget || {};
}

export function idRemotoCotizacion(id) {
  const n = Number(String(id ?? '').replace(/^r_/, ''));
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** Precio de LISTA (lo que pagó / ve el cliente) = Sección A. */
export function precioListaEquipos(q) {
  const b = presupuestoDe(q);
  return Number(b.sA || q?.section_a_cop || 0) || 0;
}

/** Precio PREFERENCIAL del proveedor (BOM cubierto). Sin oferta = lista (margen 0). */
export function precioPreferencialEquipos(q, bomSubtotal) {
  const deBom = Number(bomSubtotal || 0);
  if (deBom > 0) return deBom;
  return precioListaEquipos(q);
}

/** @deprecated usar precioListaEquipos / precioPreferencialEquipos */
export function baseEquiposCotizacion(q, bomSubtotal) {
  return precioPreferencialEquipos(q, bomSubtotal);
}

export function baseInstalacionCotizacion(q) {
  const b = presupuestoDe(q);
  return Number(b.ins || 0) || 0;
}

/**
 * @param {{ lista?: number, preferencial?: number, instalacion?: number, cargoTecPct?: number }} args
 */
export function desgloseCierre(args = {}) {
  const list = Number(args.lista || 0);
  const pref = Number(args.preferencial != null ? args.preferencial : list);
  const ins = Number(args.instalacion || 0);
  const cargoPctRaw = Number(args.cargoTecPct);
  const cargoPct = Number.isFinite(cargoPctRaw) && cargoPctRaw >= 0 ? cargoPctRaw : CARGO_ADMIN_TEC_PCT;

  const margen = Math.max(0, list - pref);
  const gastosAdmin = Math.round(margen * ADMIN_DE_MARGEN);
  const mantPlataforma = margen - gastosAdmin;
  const cargoAdminTec = Math.round(ins * cargoPct / 100);
  const fondoInfra = Math.round(cargoAdminTec * INFRA_DE_REINVERSION);
  const fondoCapacitacion = Math.round(cargoAdminTec * CAPACITACION_DE_REINVERSION);
  const fondoHerramientas = cargoAdminTec - fondoInfra - fondoCapacitacion;
  const cargoUsoPlataforma = fondoInfra + fondoHerramientas;
  const techEarnings = ins - cargoAdminTec;

  return {
    lista: list,
    preferencial: pref,
    margen,
    gastosAdmin,
    mantPlataforma,
    supplierNet: pref,
    instalacion: ins,
    cargoAdminTecPct: cargoPct,
    cargoAdminTec,
    fondoInfra,
    fondoCapacitacion,
    fondoHerramientas,
    cargoUsoPlataforma,
    techEarnings,
    shInstallFee: cargoAdminTec,
    platformFeeEquip: margen,
    feePct: list > 0 ? +((margen / list) * 100).toFixed(2) : 0,
    adminPct: 60,
    mantPct: 40,
    totalPlataforma: margen + cargoAdminTec,
    totalPlatform: margen + cargoAdminTec,
    equipos: pref,
  };
}
